import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, inject, input, output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LocaleService } from "../../../../app/services/locale.service";
import { ILocaleEntity } from "../../../../core-ui/models/interfaces";

@Component({
  selector: "av-locale-picker",
  templateUrl: "./locale-picker.component.html",
  styleUrls: ["./locale-picker.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LocalePickerComponent implements OnInit {
  private localeService = inject(LocaleService);
  private cd = inject(ChangeDetectorRef);

  readonly locales = input<ILocaleEntity[]>(undefined);

  readonly changed = output<string>();

  data: ILocaleEntity[];
  currentLocale: ILocaleEntity;
  notFoundText;
  placeholderText;

  constructor() {
    const translate = inject(TranslateService);

    this.notFoundText = translate.instant("Not found");
    this.placeholderText = translate.instant("Select time zone");
  }

  ngOnInit() {
    const locales = this.locales();
    if (locales) {
      this.data = locales;
      const lang = this.localeService.getLanguage();
      this.currentLocale = this.data.find((l) => l.language === lang);
      if (!this.currentLocale) {
        this.currentLocale = this.data[0];
      }
    } else {
      this.data = this.localeService.getLocales();
      this.currentLocale = this.localeService.getLocale();
    }
    this.data = locales || this.localeService.getLocales();
    this.cd.detectChanges();
  }

  selected(item: ILocaleEntity) {
    this.changed.emit(item.locale);
  }

  inputChanged(query) {}
}
